import { createContext, Dispatch } from 'react'

import initialState from './initial-state'

import ISearchState from '../../interfaces/search-state'
import { Action } from './reducer'

type FilterContext = {
  filter: ISearchState
  filterDispatch: Dispatch<Action>
}

const filterContext = createContext<FilterContext>({
  filter: initialState,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  filterDispatch: () => {},
})

export default filterContext
